import addFulfillmentPlanDialogTemplate from "./addFulfillmentPlanDialog/addFulfillmentPlanDialog.html";
import addFulfillmentPlanDialogController from "./addFulfillmentPlanDialog/addFulfillmentPlanDialog.controller";

class Controller {
  constructor(
    Events,
    Messages,
    $state,
    $stateParams,
    CityHandler,
    FulfillmentPlan,
    FulfillmentPlansTransforms,
    Sections,
    $mdDialog
  ) {
    "ngInject";

    this.CityHandler = CityHandler;
    this.Messages = Messages;
    this.Events = Events;
    this.$state = $state;
    this.FulfillmentPlan = FulfillmentPlan;
    this.FulfillmentPlansTransforms = FulfillmentPlansTransforms;

    this.addItemEvent = Events.getAddEvent("fulfillmentPlans");
    this.paginateEvent = Events.getPaginateEvent("fulfillmentPlans");
    this.filterEvent = Events.getFilterEvent("fulfillmentPlans");
    this.page = $stateParams.page;
    this.limit = $stateParams.limit;
    this.sections = Sections.plansSections;
    this.$mdDialog = $mdDialog;

    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;

    this.chosenCity = this.CityHandler.get();
  }

  openDialog() {
    this.$mdDialog
      .show({
        controller: addFulfillmentPlanDialogController,
        controllerAs: "$ctrl",
        template: addFulfillmentPlanDialogTemplate,
        locals: {
          chosenCity: this.chosenCity,
        },
      })
      .then(({ name, city: { _id } }) => {
        this.FulfillmentPlan.post({ name, city: _id }).$promise.then(
          ({ _id }) => {
            this.Events.emit(
              this.successNotificationEvent,
              this.Messages.addMessage("Fulfillment Plan")
            );
            this.$state.transitionTo("fulfillmentplan", {
              id: _id,
            });
          },
          (response) =>
            this.Events.emit(this.errorNotificationEvent, response.data)
        );
      });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/fulfillmentPlans/fulfillmentPlans.controller.js